package com.example.hukakmp.model

import kotlinx.serialization.Serializable

enum class AchievementCategory(
    val label: String,
    val emoji: String,
) {
    EVENTOS("Eventos", "🎁"),
    ESPECIES("Especies", "🐟"),
    HORARIOS("Horarios", "🌙"),
    ESPECIALES("Especiales", "⭐"),
}

data class AchievementDefinition(
    val id: String,
    val title: String,
    val description: String,
    val category: AchievementCategory,
    val emoji: String,
    val points: Int = 10,
)

data class AchievementState(
    val definition: AchievementDefinition,
    val isUnlocked: Boolean,
    val unlockedAtMillis: Long? = null,
)

@Serializable
data class AchievementUnlockDocument(
    val timestamp: Long = 0L,
)

object AchievementCatalog {
    val all: List<AchievementDefinition> = listOf(
        AchievementDefinition(
            id = "mi_primer_parte",
            title = "Mi Primer Parte",
            description = "Creaste tu primer parte de pesca en Huka.",
            category = AchievementCategory.ESPECIALES,
            emoji = "🎣",
            points = 10,
        ),
        AchievementDefinition(
            id = "solo_un_pez",
            title = "Solo Un Pez",
            description = "Registraste una jornada con exactamente un pez.",
            category = AchievementCategory.ESPECIALES,
            emoji = "🐟",
            points = 10,
        ),
        AchievementDefinition(
            id = "zapatero_wade",
            title = "Zapatero Wade",
            description = "No hubo capturas, pero la jornada también aporta información valiosa.",
            category = AchievementCategory.ESPECIALES,
            emoji = "🥾",
            points = 10,
        ),
        AchievementDefinition(
            id = "pesca_abundante",
            title = "Pesca Abundante",
            description = "Registraste 10 o más peces en una sola jornada.",
            category = AchievementCategory.ESPECIALES,
            emoji = "💯",
            points = 25,
        ),
        AchievementDefinition(
            id = "explorador",
            title = "Explorador",
            description = "Registraste un parte con su punto de pesca en el mapa.",
            category = AchievementCategory.ESPECIALES,
            emoji = "🗺️",
            points = 10,
        ),
        AchievementDefinition(
            id = "primera_foto",
            title = "Primera Foto",
            description = "Adjuntaste una fotografía a una jornada de pesca.",
            category = AchievementCategory.ESPECIALES,
            emoji = "📸",
            points = 10,
        ),

        AchievementDefinition(
            id = "pescador_navideño",
            title = "Pescador Navideño",
            description = "Pescaste durante las fiestas navideñas, entre el 24 y el 31 de diciembre.",
            category = AchievementCategory.EVENTOS,
            emoji = "🎄",
            points = 20,
        ),
        AchievementDefinition(
            id = "pescador_año_nuevo",
            title = "Pescador de Año Nuevo",
            description = "Empezaste el año pescando durante la primera semana de enero.",
            category = AchievementCategory.EVENTOS,
            emoji = "🎆",
            points = 20,
        ),
        AchievementDefinition(
            id = "regalo_de_reyes",
            title = "Regalo de Reyes",
            description = "Registraste una jornada el 6 de enero.",
            category = AchievementCategory.EVENTOS,
            emoji = "👑",
            points = 25,
        ),
        AchievementDefinition(
            id = "pescador_invernal",
            title = "Pescador Invernal",
            description = "Desafiaste el frío y pescaste durante el invierno argentino.",
            category = AchievementCategory.EVENTOS,
            emoji = "❄️",
            points = 15,
        ),
        AchievementDefinition(
            id = "pescador_primaveral",
            title = "Pescador Primaveral",
            description = "Aprovechaste la primavera para registrar una jornada de pesca.",
            category = AchievementCategory.EVENTOS,
            emoji = "🌱",
            points = 15,
        ),

        AchievementDefinition(
            id = "madrugador",
            title = "Madrugador",
            description = "Comenzaste a pescar entre las 05:00 y las 07:59.",
            category = AchievementCategory.HORARIOS,
            emoji = "🌅",
            points = 15,
        ),
        AchievementDefinition(
            id = "pescador_nocturno",
            title = "Pescador Nocturno",
            description = "Comenzaste a pescar entre las 19:00 y las 23:59.",
            category = AchievementCategory.HORARIOS,
            emoji = "🌙",
            points = 15,
        ),
        AchievementDefinition(
            id = "noctambulo",
            title = "Noctámbulo Extremo",
            description = "Comenzaste una jornada entre la medianoche y las 04:59.",
            category = AchievementCategory.HORARIOS,
            emoji = "🦉",
            points = 25,
        ),

        AchievementDefinition(
            id = "variedad_es_vida",
            title = "La Variedad es Vida",
            description = "Registraste cinco o más especies diferentes en una sola jornada.",
            category = AchievementCategory.ESPECIES,
            emoji = "🌈",
            points = 25,
        ),
        AchievementDefinition(
            id = "rey_del_rio",
            title = "Rey del Río",
            description = "Registraste cinco o más dorados en una sola jornada.",
            category = AchievementCategory.ESPECIES,
            emoji = "👑🐟",
            points = 50,
        ),
        AchievementDefinition(
            id = "cazador_de_dorados",
            title = "Cazador de Dorados",
            description = "Registraste tu primer dorado.",
            category = AchievementCategory.ESPECIES,
            emoji = "✨🐟",
            points = 25,
        ),
        AchievementDefinition(
            id = "amigo_del_surubi",
            title = "Amigo del Surubí",
            description = "Registraste un surubí entre tus capturas.",
            category = AchievementCategory.ESPECIES,
            emoji = "🐠",
            points = 25,
        ),
        AchievementDefinition(
            id = "pejerreyes_master",
            title = "Maestro del Pejerrey",
            description = "Registraste 10 o más pejerreyes en una sola jornada.",
            category = AchievementCategory.ESPECIES,
            emoji = "🐟🏆",
            points = 50,
        ),
    )
}
